import Service from "../../../Services/index";

const AdvanceWithdraw = {
    namespaced: true,
    state: {
        WithdrawList: [],
        WithdrawForm: {
            employee_id: "",
            advance_withdraw_amount: "",
            return_deposit_amount: "",
            date: "",
            user_id: "",
            per_month: "",
            receiver: "",
        }
    },
    mutations: {
        GET_ADVANCE_WITHDRAW: (state, res) => {
            state.WithdrawList = res.data
        },
        CLEAR_DATA_FORM: (state) => {
            state.WithdrawForm = {
                employee_id: "",
                advance_withdraw_amount: "",
                return_deposit_amount: "",
                date: "",
                user_id: "",
                per_month: "",
                receiver: "",
            }
        }
    },
    actions: {
        setAdvanceWithdraw({commit}, page = 1) {
            return Service.AdvanceWithdraw.getAdvanceWithdraw(page).then(data => {
                commit("GET_ADVANCE_WITHDRAW", data);
            })
        },
        showAdvanceWithdrawById({commit}, id) {
            return Service.AdvanceWithdraw.showAdvanceWithdraw(id);
        },
        saveAdvanceWithdraw({state}, id) {
            if (!id) {
                return Service.AdvanceWithdraw.createAdvanceWithdraw(data).then(res => {
                    //console.log(res);
                });
            } else {
                return Service.AdvanceWithdraw.updateAdvanceWithdraw(id, data).then(res => {
                    //console.log(res);
                });
            }
        },
        deleteAdvanceWithdraw(id) {
            return Service.AdvanceWithdraw.deleteAdvanceWithdraw(id);
        },
        clearData({commit}) {
            commit("CLEAR_DATA_FORM");
        }
    }
};
export default AdvanceWithdraw;
